import curd from '../curd'

const BASE_PATH = '/factor/alias/standard/name'

export default curd(BASE_PATH, {
  delAlias: (alias, factorId) => ({
    url: `${BASE_PATH}/delete/${alias}/${factorId}`,
    method: 'DELETE'
  }),
  batchSaveFactors: model => ({
    url: `${BASE_PATH}/add/batch`,
    method: 'POST',
    data: model
  }),
  save: model => ({
    url: `${BASE_PATH}`,
    method: 'PUT',
    data: model
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/FactorAlias.js